"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[57663],{

/***/ 560327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getBanners; },
/* harmony export */   "Q": function() { return /* binding */ BannerInlinePlaceholder; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _constants_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(346115);
/* harmony import */ var cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(167520);
/* harmony import */ var _types_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(901550);
/* harmony import */ var _handlers_api_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(603651);






const filterHeightInlineInRootNode = (banners, isMobile) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  let sizePopups = [];
  for (let obj of banners) {
    let content = obj.content;
    for (let key in content) {
      if (content.hasOwnProperty(key)) {
        if (content[key].parentId === "ROOT" && content[key].tag === "inlinebanner" && ((_c = (_b = (_a = content[key]) == null ? void 0 : _a.customAttributes) == null ? void 0 : _b.inlinebanner) == null ? void 0 : _c.relativePosition) === _types_es_js__WEBPACK_IMPORTED_MODULE_2__/* .ERelativePosition.IN */ .zH.IN) {
          const isPopUpShowInDesktop = !((_g = (_f = (_e = (_d = content[key]) == null ? void 0 : _d.customAttributes) == null ? void 0 : _e.inlinebanner) == null ? void 0 : _f.responsive) == null ? void 0 : _g.hiddenMd);
          const isPopUpShowInMobile = !((_k = (_j = (_i = (_h = content[key]) == null ? void 0 : _h.customAttributes) == null ? void 0 : _i.inlinebanner) == null ? void 0 : _j.responsive) == null ? void 0 : _k.hiddenXs);
          if (isMobile && isPopUpShowInMobile || !isMobile && isPopUpShowInDesktop) {
            sizePopups.push({
              className: content[key].customAttributes.inlinebanner.cssSelector,
              height: (_l = content[key].style.height) != null ? _l : 0,
              width: (_m = content[key].style.width) != null ? _m : 0
            });
          }
        }
      }
    }
  }
  return sizePopups;
};
const getBanners = async ({
  cookies,
  configs,
  env,
  flagsup
}) => {
  const { appId, iamId, trackingAppId, url, isMobile } = configs;
  const parsedCookies = cookie__WEBPACK_IMPORTED_MODULE_1__/* .parse */ .Q(cookies);
  const isNewVisitor = parsedCookies[_constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TEMPI_VP */ .CP] !== _constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .UNIDENTIFIED */ .eF || parsedCookies[_constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TEMPI_VS */ .U6] === _constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .NEW_USER */ .MB;
  const trackingId = parsedCookies[_constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TRACKING_ID */ .tz];
  const isMa79Enabled = flagsup.epic_ma_79;
  const handleSubscribe = async () => {
    if (!appId)
      return;
    try {
      const discoveryService = new _handlers_api_es_js__WEBPACK_IMPORTED_MODULE_4__/* .OnSiteDiscoveryService */ .T(env);
      const body = {
        appId,
        iamId,
        trackingAppId,
        onlyNewVisitor: isNewVisitor,
        url,
        trackingId: isMa79Enabled ? trackingId : void 0
      };
      const banners2 = await discoveryService.subscribeSmartPopup(body);
      return filterHeightInlineInRootNode(banners2, isMobile);
    } catch (e) {
      console.error(e);
    }
  };
  const banners = await handleSubscribe() || [];
  return banners;
};
const BannerInlinePlaceholder = ({
  banners = [],
  className
}) => {
  const matchBanners = banners == null ? void 0 : banners.filter(
    (banner) => banner.className === `.${className}`
  );
  const totalBannerHeight = matchBanners == null ? void 0 : matchBanners.reduce(
    (total, banner) => total + banner.height,
    0
  );
  const maxBannerWidth = matchBanners == null ? void 0 : matchBanners.reduce(
    (max, banner) => Math.max(max, banner.width),
    0
  );
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: matchBanners ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className,
      style: {
        minHeight: `${totalBannerHeight}px`,
        width: `${maxBannerWidth}px`
      }
    }) : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className
    })
  });
};




/***/ }),

/***/ 346115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CP": function() { return /* binding */ TEMPI_VP; },
/* harmony export */   "GN": function() { return /* binding */ DEFAULT_LIMIT_TIME; },
/* harmony export */   "Hi": function() { return /* binding */ RETURNING; },
/* harmony export */   "J2": function() { return /* binding */ SMART_POPUP_CONFIG; },
/* harmony export */   "MB": function() { return /* binding */ NEW_USER; },
/* harmony export */   "SI": function() { return /* binding */ EXPIRE_MINUTE; },
/* harmony export */   "U6": function() { return /* binding */ TEMPI_VS; },
/* harmony export */   "eF": function() { return /* binding */ UNIDENTIFIED; },
/* harmony export */   "hR": function() { return /* binding */ DEFAULT_DISPLAY_VALUE; },
/* harmony export */   "to": function() { return /* binding */ VIEW_INTERVAL_DURATION; },
/* harmony export */   "tz": function() { return /* binding */ TRACKING_ID; }
/* harmony export */ });
const EXPIRE_MINUTE = 20;
const TEMPI_VP = "_tempi_vp";
const TEMPI_VS = "_tempi_vs";
const SMART_POPUP_CONFIG = "_smart_banner_config";
const NEW_USER = "NEW";
const RETURNING = "RETURNING";
const UNIDENTIFIED = "unidentified";
const VIEW_INTERVAL_DURATION = 100;
const DEFAULT_DISPLAY_VALUE = 1;
const DEFAULT_LIMIT_TIME = 1;
const TRACKING_ID = "_track__track";




/***/ }),

/***/ 603651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ OnSiteDiscoveryService; }
/* harmony export */ });
/* harmony import */ var _tempi_core_renderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(988966);


const onSiteDiscoveryUrl = {
  dev: "https://smart-activation-discovery.dev.tekoapis.net/api",
  stag: "https://smart-activation-discovery.stag.tekoapis.net/api",
  production: "https://smart-activation-discovery.tempi.vn/api"
};
class OnSiteDiscoveryService {
  constructor(env) {
    this.client = new _tempi_core_renderer__WEBPACK_IMPORTED_MODULE_0__/* .Api */ .V(onSiteDiscoveryUrl[env]);
  }
  async subscribeSmartPopup(params) {
    var _a;
    const { data } = await this.client.post(
      "/v1/smart-activation/subscribe",
      params
    );
    return ((_a = data == null ? void 0 : data.data) == null ? void 0 : _a.popups) || [];
  }
}




/***/ }),

/***/ 901550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RW": function() { return /* binding */ ETimeUnit; },
/* harmony export */   "Wv": function() { return /* binding */ EBannerEvent; },
/* harmony export */   "zH": function() { return /* binding */ ERelativePosition; }
/* harmony export */ });
var EBannerEvent = /* @__PURE__ */ ((EBannerEvent2) => {
  EBannerEvent2[EBannerEvent2["DISPLAY"] = 0] = "DISPLAY";
  EBannerEvent2[EBannerEvent2["CLICK"] = 1] = "CLICK";
  EBannerEvent2[EBannerEvent2["CLOSE"] = 2] = "CLOSE";
  return EBannerEvent2;
})(EBannerEvent || {});
var ETimeUnit = /* @__PURE__ */ ((ETimeUnit2) => {
  ETimeUnit2[ETimeUnit2["MINUTE"] = 0] = "MINUTE";
  ETimeUnit2[ETimeUnit2["HOUR"] = 1] = "HOUR";
  ETimeUnit2[ETimeUnit2["SESSION"] = 1] = "SESSION";
  return ETimeUnit2;
})(ETimeUnit || {});
var ERelativePosition = /* @__PURE__ */ ((ERelativePosition2) => {
  ERelativePosition2["BEFORE"] = "before";
  ERelativePosition2["AFTER"] = "after";
  ERelativePosition2["IN"] = "in";
  return ERelativePosition2;
})(ERelativePosition || {});




/***/ }),

/***/ 309396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ProductCarouselWithHeader; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(990241);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _ProductCarousel_ProductCarousel_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(414562);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(917709);
/* harmony import */ var _BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(842918);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarouselWithHeader = (_a) => {
  var _b = _a, {
    header,
    background,
    dividerColor = "rgba(255, 255, 255, 0.5)",
    style,
    tracking,
    backgroundStyle
  } = _b, productCarouselProps = __objRest(_b, [
    "header",
    "background",
    "dividerColor",
    "style",
    "tracking",
    "backgroundStyle"
  ]);
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useDevice */ .F)();
  const MOBILE_BG_WIDTH = 856, DESKTOP_BG_WIDTH = 1232;
  const backgroundUrl = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .getImageUrlFromGoogleUserContent */ .Nc)(background, {
    width: isMobile ? MOBILE_BG_WIDTH : DESKTOP_BG_WIDTH
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    style: __spreadValues({
      minHeight: "min-content"
    }, style)
  }, !!tracking ? tracking : {}), backgroundUrl && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Background, {
    alt: (header == null ? void 0 : header.title) || "",
    src: backgroundUrl,
    width: "100%",
    height: "100%",
    style: backgroundStyle
  }), header && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBlockHeader, __spreadProps(__spreadValues({}, header), {
    borderColor: dividerColor
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledProductCarousel, __spreadValues({}, productCarouselProps)));
};
ProductCarouselWithHeader.displayName = "ProductCarouselWithHeader";
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  position: relative;
`;
const Background = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].img`
  position: absolute;
  top: 0;
`;
const StyledProductCarousel = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_ProductCarousel_ProductCarousel_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCarousel */ .G)`
  padding: 12px;
`;
const StyledBlockHeader = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_5__/* .BlockHeader */ .t)`
  border-bottom: 1px solid ${(props) => props.borderColor};
  .title {
    padding: 0 8px;
  }
`;




/***/ }),

/***/ 380822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ s; }
/* harmony export */ });
class s{constructor(s,e,t){this.message=s,this.response=t,this.code=e}get reason(){return this.response}}


/***/ }),

/***/ 988966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ u; }
/* harmony export */ });
/* harmony import */ var opentracing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83492);
/* harmony import */ var opentracing__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(opentracing__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _error_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(380822);
var s=Object.defineProperty,a=Object.defineProperties,n=Object.getOwnPropertyDescriptors,o=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,p=(t,e,r)=>e in t?s(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,h=(t,e)=>{for(var r in e||(e={}))i.call(e,r)&&p(t,r,e[r]);if(o)for(var r of o(e))c.call(e,r)&&p(t,r,e[r]);return t};const l=(t="",e)=>`${t.endsWith("/")?t.slice(0,t.length-1):t}/${e.startsWith("/")?e.slice(1):e}`;class u{constructor(t,e,r={}){this.baseURL=t,this.interceptors=[],this.getError=e,this.defaultConfig=r}_parseJson(t){return t.text().then((t=>t?JSON.parse(t):null))}addInterceptor(t){this.interceptors.push(t)}appendParamsToURL(t,e={}){if(e){const r=[];for(const t of Object.keys(e))null!==e[t]&&void 0!==e[t]&&r.push(`${t}=${encodeURIComponent(e[t])}`);r.length>0&&(t=`${t}?${r.join("&")}`)}return t}async request(s,o,i,c={}){var p;const{params:u}=c;let f=c.headers||{};const d=this.appendParamsToURL(s,u||{});let g=null;const y=o&&"string"!=typeof o&&"append"in o;o&&"string"!=typeof o&&(y?g=new URLSearchParams(o).toString():(g=JSON.stringify(o),f=h({"Content-Type":"application/json"},f)));let b=null;u&&(b=JSON.stringify(u));const m=(0,opentracing__WEBPACK_IMPORTED_MODULE_0__.globalTracer)(),w=`[${i}] ${l(this.baseURL,s)}`,O=m.startSpan(w);m.inject(O,opentracing__WEBPACK_IMPORTED_MODULE_0__.FORMAT_HTTP_HEADERS,f),O.setTag("http.method",i),O.setTag("http.baseurl",this.baseURL),O.log({body:g,params:b});const j=(P=h({},this.defaultConfig),T={method:i,headers:new Headers(f),body:y?o:g},a(P,n(T)));var P,T;this.interceptors.forEach((t=>t(j)));const E=await fetch(d.startsWith("http")?d:l(this.baseURL,d),j);if(E.status>=400){const t=await E.json(),e=(null==(p=this.getError)?void 0:p.call(this,t))||new _error_es_js__WEBPACK_IMPORTED_MODULE_1__/* .ApiError */ .M("Đã có lỗi xảy ra, vui lòng thử lại sau!",-1,t);return O.setTag("status","error"),O.log({error:JSON.stringify(e)}),O.finish(),Promise.reject(e)}const v={};E.headers.forEach(((t,e)=>v[e]=t));const S=await this._parseJson(E);return O.setTag("status","success"),O.finish(),{code:E.status,data:S,headers:v}}async get(t,e={}){return await this.request(t,null,"GET",e)}async post(t,e,r={}){return await this.request(t,e,"POST",r)}async patch(t,e,r={}){return await this.request(t,e,"PATCH",r)}async put(t,e,r={}){return await this.request(t,e,"PUT",r)}async delete(t,e={},r={}){return await this.request(t,e,"DELETE",r)}}


/***/ }),

/***/ 957663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ DiscoveryBlocks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(982226);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var reflexbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(504545);
/* harmony import */ var _teko_discovery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(875663);
/* harmony import */ var helpers_block__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(997441);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(775002);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _LazyComponent__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(110413);
/* harmony import */ var _tekface_smart_activation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(560327);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(124177);
/* harmony import */ var _RecentViewedProducts__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(751817);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  top: -92px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













const DiscoveryRecommendedProducts = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 97657).then(__webpack_require__.bind(__webpack_require__, 910769)).then((mod)=>mod.DiscoveryRecommendedProducts), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(910769)
            ]
    }
});
const ProductListWithFilter = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(60687), __webpack_require__.e(37070), __webpack_require__.e(97968), __webpack_require__.e(50643), __webpack_require__.e(25552)]).then(__webpack_require__.bind(__webpack_require__, 325552)).then((mod)=>mod.ProductListWithFilter), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(325552)
            ]
    }
});
const TIME_TO_RENDER = 0;
const FeaturedBanners = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(2026), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(28644)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.FeaturedBanners), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const PromoteBlock = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(2026), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(28644)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.PromoteBlock), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const HotDealSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(81633), __webpack_require__.e(27566)]).then(__webpack_require__.bind(__webpack_require__, 927566)).then((mod)=>mod.HotDealSection), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(927566)
            ]
    }
});
const BestSellingProductsBlock = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 83648).then(__webpack_require__.bind(__webpack_require__, 783648)).then((mod)=>mod.BestSellingProductsBlock), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(783648)
            ]
    }
});
const NavigationBarBlock = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 14956).then(__webpack_require__.bind(__webpack_require__, 414956)).then((mod)=>mod.NavigationBarBlock), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(414956)
            ]
    }
});
const YoutubeBlock = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 68397).then(__webpack_require__.bind(__webpack_require__, 768397)).then((mod)=>mod.YoutubeBlock), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(768397)
            ]
    }
});
const LeftRightStickyBannerBlock = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 19931).then(__webpack_require__.bind(__webpack_require__, 937420)).then((mod)=>mod.LeftRightStickyBannerBlock), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(937420)
            ]
    }
});
const ListCategories = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(2026), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(28644)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.ListCategories), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const FeaturedBrands = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(2026), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(28644)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.FeaturedBrands), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const FlashSaleBlock = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 79855).then(__webpack_require__.bind(__webpack_require__, 579855)).then((mod)=>mod.FlashSaleBlock), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(579855)
            ]
    }
});
const BlockAnchor = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject());
const DiscoveryBlocks = (param)=>{
    let { blocks , customRenderer , filterPrice =undefined , ssrMapProducts , filters , inlineBanners , pageTypeEnum  } = param;
    const categoryProductBlockRendered = [];
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { query  } = router;
    const mainSkuList = (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.MAIN_SKU_LIST */ .kH.MAIN_SKU_LIST, blocks);
    const leftStickyBanner = (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.LEFT_STICKY_BANNER */ .kH.LEFT_STICKY_BANNER, blocks);
    const rightStickyBanner = (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.RIGHT_STICKY_BANNER */ .kH.RIGHT_STICKY_BANNER, blocks);
    const youtubeBlock = (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.YOUTUBE */ .kH.YOUTUBE, blocks);
    const navigationBarBlock = (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.NAVIGATION_BAR */ .kH.NAVIGATION_BAR, blocks);
    const isDefaultBlock = blocks.length === 2 && mainSkuList;
    if (isDefaultBlock) {
        const fetchParams = _objectSpreadProps(_objectSpread({}, mainSkuList.content.fetchParams), {
            blockId: mainSkuList.id
        });
        const filterParams = _objectSpreadProps(_objectSpread({}, fetchParams.filter, fetchParams.sorting), {
            blockId: mainSkuList.id
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductListWithFilter, {
            serverProducts: ssrMapProducts === null || ssrMapProducts === void 0 ? void 0 : ssrMapProducts[mainSkuList.id],
            filterPrice: filterPrice,
            serverFilters: filters,
            customerParams: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_8__.cleanObject)(_objectSpread({}, filterParams, query))
        });
    }
    const firstCountdownBlockIndex = blocks.findIndex((block)=>block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.COUNT_DOWN_PROMO_BIG_SKU */ .kH.COUNT_DOWN_PROMO_BIG_SKU);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            navigationBarBlock && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavigationBarBlock, {
                block: navigationBarBlock,
                blockList: blocks
            }),
            youtubeBlock && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                        id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(youtubeBlock)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(YoutubeBlock, {
                        block: youtubeBlock
                    })
                ]
            }),
            (leftStickyBanner || rightStickyBanner) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LeftRightStickyBannerBlock, {
                leftBlock: leftStickyBanner,
                rightBlock: rightStickyBanner,
                stickyTop: navigationBarBlock ? 112 : 72
            }),
            firstCountdownBlockIndex === -1 && pageTypeEnum === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .PageTypeEnum.HOME */ .DZ.HOME ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tekface_smart_activation__WEBPACK_IMPORTED_MODULE_10__/* .BannerInlinePlaceholder */ .Q, {
                    banners: inlineBanners,
                    className: _constants__WEBPACK_IMPORTED_MODULE_11__/* .INLINE_BANNER_CLASSNAME.INLINE_HOME_BODY */ .h.INLINE_HOME_BODY
                })
            }) : null,
            blocks.map((block, index, list)=>{
                var ref, ref1, ref2;
                const showBannerHorizontal = block.itemType === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockItemType.BANNER */ .Nc.BANNER && block.type.startsWith("HORIZONTAL") && block.type !== _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.HORIZONTAL_4_BANNER */ .kH.HORIZONTAL_4_BANNER && (block === null || block === void 0 ? void 0 : (ref = block.cookedData) === null || ref === void 0 ? void 0 : ref.length);
                const showCategoryProductBlock = block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.MIX_BANNER */ .kH.MIX_BANNER && index > 1 && !categoryProductBlockRendered.includes(list[index - 1].id) && list[index - 1].type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.MIX_BANNER */ .kH.MIX_BANNER;
                const showTopBrands = block.itemType === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockItemType.MENU */ .Nc.MENU && block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.HORIZONTAL_HIGHLIGHTED_BANNER */ .kH.HORIZONTAL_HIGHLIGHTED_BANNER && (block === null || block === void 0 ? void 0 : (ref1 = block.cookedData) === null || ref1 === void 0 ? void 0 : ref1.length);
                const showCustomCategories = block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.PROMOTE_CATEGORY_MENU */ .kH.PROMOTE_CATEGORY_MENU && (block === null || block === void 0 ? void 0 : (ref2 = block.cookedData) === null || ref2 === void 0 ? void 0 : ref2.length);
                const ConditionalLazyComponent = block.ssr ? react__WEBPACK_IMPORTED_MODULE_2__.Fragment : _LazyComponent__WEBPACK_IMPORTED_MODULE_12__/* .LazyComponent */ .c;
                if (showCustomCategories) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                        marginBottom: "s24",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                                id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(block)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListCategories, {
                                categories: block.cookedData.map((category)=>{
                                    return {
                                        title: category.campaignName,
                                        image: {
                                            src: category.image
                                        },
                                        link: {
                                            href: category.targetPath
                                        }
                                    };
                                }),
                                header: {
                                    title: block.label
                                }
                            })
                        ]
                    }, index);
                }
                if (showTopBrands) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConditionalLazyComponent, {
                    timeToRender: TIME_TO_RENDER,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                        marginBottom: "s24",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                                id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(block)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeaturedBrands, {
                                header: {
                                    title: block.label
                                },
                                brands: block.cookedData.map((bl)=>({
                                        name: bl.campaignName,
                                        description: bl.description,
                                        image: {
                                            src: bl.image
                                        },
                                        link: {
                                            href: bl.targetPath
                                        }
                                    }))
                            })
                        ]
                    })
                }, index);
                if (showCategoryProductBlock) {
                    categoryProductBlockRendered.push(block.id);
                    categoryProductBlockRendered.push(list[index - 1].id);
                    const categoryBlock1 = list[index - 1].cookedData;
                    const categoryBlock2 = block.cookedData;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConditionalLazyComponent, {
                        timeToRender: TIME_TO_RENDER,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                                    id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(block)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
                                    marginBottom: 24,
                                    flexWrap: "wrap",
                                    mx: -2,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reflexbox__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                                            width: [
                                                1,
                                                1 / 2
                                            ],
                                            px: 2,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PromoteBlock, _objectSpread({}, categoryBlock1))
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reflexbox__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                                            width: [
                                                1,
                                                1 / 2
                                            ],
                                            px: 2,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PromoteBlock, _objectSpread({}, categoryBlock2))
                                        })
                                    ]
                                })
                            ]
                        })
                    }, index);
                }
                // block.cookedData is the result of transformBanner function
                if (showBannerHorizontal) {
                    const banners = block.cookedData.map((banner)=>{
                        return {
                            src: banner.image,
                            link: {
                                href: banner.targetPath
                            },
                            name: banner.campaignName
                        };
                    });
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                        marginBottom: "s24",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                                id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(block)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeaturedBanners, {
                                banners: banners,
                                regionName: "horizontalBanner".concat(banners.length)
                            })
                        ]
                    }, index);
                }
                if (customRenderer) {
                    // for other block types
                    // allow an input customRenderer to overwrite
                    // the default input
                    const blockNode = customRenderer(block, index);
                    if (blockNode) return blockNode;
                }
                if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.COUNT_DOWN_PROMO_SKU */ .kH.COUNT_DOWN_PROMO_SKU || block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.FLASH_SALE */ .kH.FLASH_SALE) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                                id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(block)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FlashSaleBlock, {
                                block: block,
                                ssrProducts: ssrMapProducts === null || ssrMapProducts === void 0 ? void 0 : ssrMapProducts[block.id]
                            })
                        ]
                    }, index);
                }
                if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.HORIZONTAL_SKU_LIST */ .kH.HORIZONTAL_SKU_LIST || block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.BEST_SELLING_PRODUCT */ .kH.BEST_SELLING_PRODUCT) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConditionalLazyComponent, {
                        timeToRender: TIME_TO_RENDER,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                            marginBottom: "s24",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                                    id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(block)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BestSellingProductsBlock, {
                                    block: block,
                                    ssrProducts: ssrMapProducts === null || ssrMapProducts === void 0 ? void 0 : ssrMapProducts[block.id]
                                })
                            ]
                        })
                    }, index);
                }
                if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.COUNT_DOWN_PROMO_BIG_SKU */ .kH.COUNT_DOWN_PROMO_BIG_SKU) {
                    var ref3, ref4, ref5;
                    const serverItemId = block === null || block === void 0 ? void 0 : (ref3 = block.cookedData) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.paramsObject) === null || ref5 === void 0 ? void 0 : ref5.itemId;
                    const ssrProducts = ssrMapProducts === null || ssrMapProducts === void 0 ? void 0 : ssrMapProducts["".concat(block.id, "_").concat(serverItemId)];
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                                marginBottom: "s24",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                                        id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(block)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HotDealSection, {
                                        block: block,
                                        ssrProducts: ssrProducts
                                    })
                                ]
                            }, index),
                            firstCountdownBlockIndex === index && pageTypeEnum === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .PageTypeEnum.HOME */ .DZ.HOME ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                                style: {
                                    overflow: "hidden"
                                },
                                marginBottom: "s24",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tekface_smart_activation__WEBPACK_IMPORTED_MODULE_10__/* .BannerInlinePlaceholder */ .Q, {
                                    banners: inlineBanners,
                                    className: _constants__WEBPACK_IMPORTED_MODULE_11__/* .INLINE_BANNER_CLASSNAME.INLINE_HOME_BODY */ .h.INLINE_HOME_BODY
                                })
                            }, "BannerInlinePlaceholder") : null
                        ]
                    });
                }
                if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.MAIN_SKU_LIST */ .kH.MAIN_SKU_LIST || block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.PROMOTE_SELLER */ .kH.PROMOTE_SELLER) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConditionalLazyComponent, {
                        timeToRender: TIME_TO_RENDER,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                            marginBottom: "s24",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                                    id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(block)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DiscoveryRecommendedProducts, {
                                    title: block.label,
                                    paramsObject: _objectSpreadProps(_objectSpread({}, block.cookedData.paramsObject), {
                                        blockId: block.id
                                    }),
                                    actionLink: block.viewMoreUrl ? {
                                        href: block.viewMoreUrl
                                    } : undefined,
                                    ssrProducts: ssrMapProducts === null || ssrMapProducts === void 0 ? void 0 : ssrMapProducts[block.id]
                                })
                            ]
                        }, index)
                    }, index);
                }
                if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.RECENT_PRODUCT */ .kH.RECENT_PRODUCT) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConditionalLazyComponent, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RecentViewedProducts__WEBPACK_IMPORTED_MODULE_13__/* .RecentViewedProducts */ .Z, {})
                    }, index);
                }
            })
        ]
    });
};


/***/ }),

/***/ 751817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RecentViewedProducts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(982226);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(640128);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(743126);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(309396);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(679376);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(788813);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88837);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(185081);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









const RecentViewedProducts = (props)=>{
    const { render , excludedSkus  } = props, rest = _objectWithoutProperties(props, [
        "render",
        "excludedSkus"
    ]);
    const recentViewedProductsSkus = (0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .isServerless */ .ep)() ? (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .parseJsonStringSafely */ .O)(localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_4__/* .RECENTLY_VIEWED_PRODUCTS_KEY */ ._V) || "[]", []) || [] : [];
    const { result , isLoading  } = (0,hooks__WEBPACK_IMPORTED_MODULE_5__/* .useSearch */ .Rx)(recentViewedProductsSkus.length ? {
        filter: {
            skus: recentViewedProductsSkus,
            excludedSkus: excludedSkus
        },
        pageSize: 50,
        page: 1
    } : {});
    const products = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const newProducts = [];
        recentViewedProductsSkus.forEach((sku)=>{
            const productFoundBySku = result.products.find((item)=>item.sku === sku);
            if (productFoundBySku) {
                newProducts.push(productFoundBySku);
            }
        });
        return newProducts;
    }, [
        result.products
    ]);
    if (!products.length && !isLoading) return null;
    return !!render ? render(products) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W, _objectSpreadProps(_objectSpread({}, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_7__/* .ProductCarouselWithHeader */ .B, {
                header: {
                    title: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Sản phẩm vừa xem")
                },
                products: products,
                regionName: "viewedItem"
            })
        })
    }));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__["default"].div(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .CommonStyles */ .F, "\n    background: white;\n    border-radius: 0.5rem;\n    margin-bottom: 1.5rem;\n    .product-card{\n      border: 1px solid ".concat(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .themeColor.divider */ .E.divider, ";\n      border-radius: 4px;\n    }\n  "));


/***/ }),

/***/ 167520:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.Q = parse;
__webpack_unused_export__ = serialize;

/**
 * Module variables.
 * @private
 */

var __toString = Object.prototype.toString

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var dec = opt.decode || decode;

  var index = 0
  while (index < str.length) {
    var eqIdx = str.indexOf('=', index)

    // no more cookie pairs
    if (eqIdx === -1) {
      break
    }

    var endIdx = str.indexOf(';', index)

    if (endIdx === -1) {
      endIdx = str.length
    } else if (endIdx < eqIdx) {
      // backtrack on prior semicolon
      index = str.lastIndexOf(';', eqIdx - 1) + 1
      continue
    }

    var key = str.slice(index, eqIdx).trim()

    // only assign once
    if (undefined === obj[key]) {
      var val = str.slice(eqIdx + 1, endIdx).trim()

      // quoted values
      if (val.charCodeAt(0) === 0x22) {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }

    index = endIdx + 1
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    var expires = opt.expires

    if (!isDate(expires) || isNaN(expires.valueOf())) {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + expires.toUTCString()
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.partitioned) {
    str += '; Partitioned'
  }

  if (opt.priority) {
    var priority = typeof opt.priority === 'string'
      ? opt.priority.toLowerCase()
      : opt.priority

    switch (priority) {
      case 'low':
        str += '; Priority=Low'
        break
      case 'medium':
        str += '; Priority=Medium'
        break
      case 'high':
        str += '; Priority=High'
        break
      default:
        throw new TypeError('option priority is invalid')
    }
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * URL-decode string value. Optimized to skip native call when no %.
 *
 * @param {string} str
 * @returns {string}
 */

function decode (str) {
  return str.indexOf('%') !== -1
    ? decodeURIComponent(str)
    : str
}

/**
 * URL-encode value.
 *
 * @param {string} val
 * @returns {string}
 */

function encode (val) {
  return encodeURIComponent(val)
}

/**
 * Determine if value is a Date.
 *
 * @param {*} val
 * @private
 */

function isDate (val) {
  return __toString.call(val) === '[object Date]' ||
    val instanceof Date
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ })

}]);